import type { FC } from "react"

import { TelecomContainer } from "commons"

const OnboardingStepContact: FC<Props> = ({ organizationId, organizationName }) => (
  <div className="flex flex-col gap-6 md:gap-8">
    <div>
      <h2 className="text-2xl leading-6 font-semibold text-gray-900">Email &amp; phone number</h2>
      <p className="text-base leading-5 text-gray-500 mt-2">
        Your email becomes your login. Phone is optional for appointment reminders.
      </p>
    </div>
    <TelecomContainer
      checkEmailExists
      patientOrganization={{ id: organizationId, name: organizationName ?? "" }}
      isPhoneOptional
      showPhoneOptionalCaption
      inputClassName="!h-[2.625rem]"
    />
  </div>
)

type Props = {
  organizationId: string
  organizationName?: string
}

export { OnboardingStepContact }
